import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Blockies from 'react-blockies';
import logo from '../logo.png';
import { connectProvider } from '../store/reducers/provider';
import {
  getNetworkLabel,
  isSupportedChain,
  HARDHAT_CHAIN_ID,
  SEPOLIA_CHAIN_ID,
  SEPOLIA_HEX,
} from '../utils/network';
import { shortenAddress } from '../utils/format';

const NAV_ITEMS = [
  { to: '/', label: 'Swap', end: true },
  { to: '/deposit', label: 'Deposit' },
  { to: '/withdraw', label: 'Withdraw' },
  { to: '/charts', label: 'Charts' },
];

const Navigation = () => {
  const dispatch = useDispatch();
  const { account, chainId, loading } = useSelector((state) => state.provider);

  const connectHandler = () => {
    if (!window.ethereum) {
      console.error('MetaMask not installed or window.ethereum missing.');
      return;
    }
    dispatch(connectProvider());
  };

  const networkHandler = async (e) => {
    const next = e.target.value;
    if (!next || next === '0') return;
    try {
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: next }],
      });
    } catch (error) {
      console.error('Network switch failed', error);
    }
  };

  const selectValue = (() => {
    if (Number(chainId) === SEPOLIA_CHAIN_ID) return SEPOLIA_HEX;
    if (Number(chainId) === HARDHAT_CHAIN_ID) return '0x7a69';
    return '0';
  })();

  const supported = isSupportedChain(chainId);

  return (
    <header className="app-header">
      <div className="app-header__inner">
        <a className="app-brand" href="#/" aria-label="Davids AMM home">
          <img className="app-brand__logo" src={logo} alt="" width="36" height="36" />
          <span className="app-brand__name">Davids AMM</span>
        </a>

        <nav className="app-nav" aria-label="Primary">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `app-nav__link${isActive ? ' is-active' : ''}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="app-header__actions">
          <div className={`pill${supported ? ' pill--accent' : ' pill--muted'}`}>
            {supported && <span className="pill__dot" aria-hidden="true" />}
            <label className="visually-hidden" htmlFor="network-select">
              Network
            </label>
            <select
              id="network-select"
              aria-label="Network"
              value={selectValue}
              onChange={networkHandler}
            >
              <option value="0" disabled>
                {chainId && !supported ? getNetworkLabel(chainId) : 'Network'}
              </option>
              <option value={SEPOLIA_HEX}>Sepolia</option>
              <option value="0x7a69">Localhost 31337</option>
            </select>
          </div>

          {account ? (
            <div className="pill pill--account" title={account}>
              <span>{shortenAddress(account, 4, 4)}</span>
              <span className="pill__identicon" aria-hidden="true">
                <Blockies
                  seed={account}
                  size={8}
                  scale={3}
                  color="#6366f1"
                  bgColor="#121826"
                  spotColor="#8b5cf6"
                />
              </span>
            </div>
          ) : (
            <button
              type="button"
              className="btn btn--secondary"
              onClick={connectHandler}
              disabled={loading}
              style={{ minHeight: 36, padding: '0 14px', fontSize: '0.85rem' }}
            >
              {loading ? 'Connecting…' : 'Connect Wallet'}
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navigation;
